var React = require('react');

function DSL (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M14 7.204c0-1.636 1.565-2.7 2.894-1.969l13.528 7.443c.162.09.306.197.433.318H38c5.523 0 10 4.927 10 11.004s-4.477 11.004-10 11.004h-4v5.792c0 1.636-1.565 2.7-2.894 1.969l-13.528-7.443a2.044 2.044 0 01-.433-.318H10C4.477 35.004 0 30.077 0 24s4.477-11.004 10-11.004h4V7.204zm20 24.499V25.91c0-1.636-1.565-2.7-2.895-1.968l-13.527 7.443a2.042 2.042 0 00-.433.318H10c-3.866 0-7-3.449-7-7.703 0-4.254 3.134-7.703 7-7.703h4v5.793c0 1.636 1.565 2.7 2.894 1.968l13.528-7.443c.162-.09.306-.196.433-.318H38c3.866 0 7 3.449 7 7.703 0 4.254-3.134 7.703-7 7.703h-4z"}));
}

DSL.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = DSL;

DSL.default = DSL;
